var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded my-auto mb-3"},[_c('div',{class:[
      'block',
      'text-sm',
      'text-gray-900',
      'hover:text-gray-900',
      'hover:bg-gray-100',
      'focus:outline-none',
      'shadow',
      'my-2',
      'overflow-hidden',
      'border-t',
      'border-b',
      'border-orange-600',
      _vm.focused ? 'bg-orange-200' : 'bg-white',
      _vm.starting ? 'rounded-l' : 'rounded-r',
      _vm.starting ? 'border-l-4' : 'border-r-4',
    ],on:{"click":_vm.clickAction}},[_c('div',{staticClass:"p-2"},[_c('p',{staticClass:"text-xs",class:[_vm.focused ? 'text-orange-600' : 'text-gray-600']},[_vm._v(" "+_vm._s(_vm.campaign.name)+" ")]),(_vm.campaign.totalActiveChannels > 0)?_c('span',{staticClass:"inline-block text-orange-600 text-xs font-medium bg-orange-200 rounded-full px-3 leading-6 mt-2"},[_vm._v(" Active ")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }